import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { AppView } from '../../../../components/AppView'
import Helmet from 'react-helmet'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { PermissionNames } from '@getgreenline/homi-shared'
import { NoPermissionsResult } from '../../../../components/NoPermissionsResult'
import { Outreach } from './Outreach'

interface Props {
  currentUserStore?: CurrentUserStore
  currentCompanyStore?: CurrentCompanyStore
}

const _DashboardOutreach = (props: Props) => {
  const canViewCustomers = props.currentUserStore!.hasPermissionAtEntity(
    PermissionNames.CAN_VIEW_CUSTOMERS,
    props.currentCompanyStore!.company!.id,
  )

  const canManageOutreach = props.currentUserStore!.hasPermissionAtEntity(
    PermissionNames.CAN_MANAGE_OUTREACH,
    props.currentCompanyStore!.company!.id,
  )

  return (
    <AppView column>
      <Helmet>
        <title>Customers | Outreach</title>
        <meta name='page-loaded' content='true' />
      </Helmet>

      {canViewCustomers && canManageOutreach ? (
        <Outreach />
      ) : (
        <NoPermissionsResult
          permissionName={
            !canManageOutreach
              ? PermissionNames.CAN_MANAGE_OUTREACH
              : PermissionNames.CAN_VIEW_CUSTOMERS
          }
        />
      )}
    </AppView>
  )
}

export const DashboardOutreach = inject(
  'currentUserStore',
  'currentCompanyStore',
)(observer(_DashboardOutreach))
